import React, { useContext, ReactNode } from 'react';

// Context
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

// Components
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

// Styles
import './TeamGroupTemplate.scss';

type Props = {
  title: string | ReactNode;
  addButtonLabel: string;
  tooltipLabel: string;
  children: React.ReactNode;
  onAddClick: Function;
  onCloseNavbar: Function;
};

function TeamGroupTemplate({ title, addButtonLabel, tooltipLabel, children, onAddClick, onCloseNavbar }: Props) {
  const isExpanded = useContext(ExpandNavbarContext);

  const { isZoom } = useApp();

  const handleAddButtonClick = () => {
    (window as any).analytics.track('Clicked in Sidebar', { button: addButtonLabel });
    (window as any).analytics.track('Clicked Add Workspace', { isGroup: true, isMultiple: false, source: 'sidebar' });
    onCloseNavbar();
    onAddClick();
  };

  const baseClassName = 'team-group-template';

  return (
    <div className={`${baseClassName} mb-3`}>
      {isExpanded ? (
        <div
          className={`${baseClassName}-title pt-3 px-2 d-flex justify-content-between align-items-center border-top text-muted`}
        >
          <span>{title}</span>
        </div>
      ) : (
        <hr className="my-1 w-100" />
      )}
      <div className={`${baseClassName}-content my-3 w-100`}>{children}</div>
      <div>
        {!isZoom && isExpanded && (
          <WpButton
            variant="secondary"
            size="lg"
            onClick={handleAddButtonClick}
            block
            qaTest="sidebar-add-workspace-button"
          >
            <WpIcon name="plus-circle" />
            {addButtonLabel}
          </WpButton>
        )}
        {!isZoom && !isExpanded && (
          <div className="w-100 text-center">
            <WpTooltip placement="right">
              <WpTooltipTrigger>
                <WpButton variant="tertiary" size="sm" onClick={handleAddButtonClick}>
                  <WpIcon name="plus-circle" />
                </WpButton>
              </WpTooltipTrigger>
              <WpTooltipContent>{tooltipLabel}</WpTooltipContent>
            </WpTooltip>
          </div>
        )}
      </div>
    </div>
  );
}

export default TeamGroupTemplate;
